import React from 'react';
import './css/ChatBox.css';
import ChatWindow from './ChatWindow';
import LargeTextBox from './LargeTextBox/LargeTextBox';


function ChatBox(){
    return(
        <div className="chatbox">
            <div className="viewWindow">
                <ChatWindow></ChatWindow>
            </div>
            <div>
                <LargeTextBox></LargeTextBox>
            </div>
        </div>
    )
}

export default ChatBox;